'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var styled = require('styled-components');
var DeliveryInfo_ChristimasDeliveryInfo_index = require('./ChristimasDeliveryInfo/index.js');
var DeliveryInfo_ETAInfo_index = require('./ETAInfo/index.js');
var DeliveryInfo_ReturnInfo_index = require('./ReturnInfo/index.js');
var DeliveryInfo_WestwingDeliveryService_index = require('./WestwingDeliveryService/index.js');
var DeliveryInfo_TwoManHandlingCTA_index = require('./TwoManHandlingCTA/index.js');
var DeliveryInfo_PhoneInfo_index = require('./PhoneInfo/index.js');
require('react');
require('../common-135480f3.js');
require('../typography/index.js');
require('../Icons/Svgs/DeliveryBeforeXmasIcon/index.js');
require('../Icons/Svgs/DeliveryIcon/index.js');
require('../Icons/Svgs/ReturnIcon/index.js');
require('../Icons/Svgs/WestwingDeliveryServiceLogo/index.js');
require('../Icons/Svgs/DeliveryIconColored/index.js');
require('../viewport.utils-0c2b4e2b.js');
require('../NoticeTag/index.js');
require('../Icons/PhoneIcon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var DeliveryInfoContainer = styled__default['default'].div.withConfig({ displayName: "ww-uikit_DeliveryInfoContainer_lty9a1aa", componentId: "sc-1vlaqp6" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    border: 1px solid ", ";\n"], ["\n    border: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal20;
});
var DeliveryInfo = {
    Container: DeliveryInfoContainer,
    ETA: DeliveryInfo_ETAInfo_index['default'],
    Return: DeliveryInfo_ReturnInfo_index['default'],
    WestingDeliveryService: DeliveryInfo_WestwingDeliveryService_index['default'],
    Christimas: DeliveryInfo_ChristimasDeliveryInfo_index['default'],
    TwoManHandlingCTA: DeliveryInfo_TwoManHandlingCTA_index['default'],
    Phone: DeliveryInfo_PhoneInfo_index['default'],
};
var templateObject_1;

exports.DeliveryInfoContainer = DeliveryInfoContainer;
exports.default = DeliveryInfo;
//# sourceMappingURL=index.js.map
